<img
  *ngIf="showWarning"
  class="warning-icon"
  src="{{ iconPath }}"
  [matTooltip]="(propertyName ? (propertyName | translate) + ' ' : '') + (tooltip | translate)"
  matTooltipPosition="above"
  matTooltipClass="orms-tooltip-common"
  alt="{{ 'imgAlt.warning' | translate }}"
/>
